import React, {useState} from 'react';
import Button from "../../../../components/button/button.jsx";
import {Modal} from "../../../../components/modal/modal.jsx";
import InputTextarea from "../../../../components/input/input-textarea.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import bosService from "../../../../services/web/bos-service.js";

const BoInvalidate = ({ id, actionsItems, boName, setIsLoading, callBack }) => {
    const [modalInvalidate, setModalInvalidate] = useState(false);
    const [invalidateObs, setInvalidateObs] = useState("");

    const invalidate = () => {
        if (!invalidateObs){
            projectUtils.swalErrorMessage("", "O campo \"Justificativa\" é obrigatório.");
            return;
        }

        const body = {
            id: id,
            observation: invalidateObs,
        }

        setIsLoading(true)
        bosService.invalidate(new URLSearchParams(body))
            .then(() => {
                callBack()
                setTimeout(() => setModalInvalidate(false), 1000);
            })
            .catch(error => {
                console.error(error);
                let message = `Erro ao invalidar ${boName}.`;
                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <section className={"print:hidden"}>
            {
                actionsItems?.invalidate &&
                <Button target={"danger"} className={"justify-self-end"} onClick={() => setModalInvalidate(true)}>
                    INVALIDAR
                </Button>
            }

            <Modal open={modalInvalidate} setOpen={setModalInvalidate} title={`Invalidar o ${boName} ${id}?`} className={"w-6/12"} overflow={true}>
                <Modal.Body className={"space-y-4"}>
                    <InputTextarea
                        id={"rejectObs"}
                        value={invalidateObs}
                        label={"Justificativa *"}
                        textAreaClass={"h-[120px]"}
                        onChange={({target: {value}}) => setInvalidateObs(value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={invalidate}
                        actionFeedbackType="save"
                        loadingText="Invalidando..."
                        successText="Invalidado com sucesso"
                    >
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </section>
    );
};

export default BoInvalidate;